import { css } from 'styled-components';
import { NavItemProps } from '../../../../../components/InPageNav/InPageNavDesktop/NavItemDesktop/styles';
import { NavText } from '../../../../../components/InPageNav/InPageNavDesktop/styles';
import spacing from '../../../../../helpers/spacing';
import { colors, themeSpecificColors } from '../../../colors';
import { fonts, fontWeightMedium } from '../../../fonts';

export default css<NavItemProps>`
  && {
    ${fonts.paragraphSmall};
    font-weight: ${fontWeightMedium};
    color: ${colors.neutral02};
    border-left: none;
    border-bottom: solid 1px ${colors.neutral04};
    box-sizing: border-box;
    padding: ${spacing(2)} 0;

    & > ${NavText} {
      width: 100%;
      padding: 2px;
    }

    &:first-of-type {
      padding-top: ${spacing(2)};
    }
    &:last-child {
      padding-bottom: ${spacing(2)};
    }

    &:focus-visible {
      & > ${NavText} {
        box-shadow: none;
      }
    }

    &:hover {
      color: ${colors.core01};
    }

    &:active {
      // According to design, the space between box-shadow and border-bottom (when active)
      // should be the same as the space between text and border-bottom (when not active).
      // Similar for focus-visible.
      padding: 18px 2px; // 16px (original padding) + 2px (thickness of box-shadow)
      & > ${NavText} {
        color: ${colors.neutral01};
        text-decoration: none;
        box-shadow: 0 0 0 2px ${colors.core01};
        border-radius: 0;
      }
    }
    &:focus-visible {
      padding: 22px 6px;
      & > ${NavText} {
        background-color: ${colors.neutral08};
        color: ${colors.neutral01};
        text-decoration: none;
        box-shadow: 0 0 0 2px ${colors.core01}, 0 0 0 6px ${themeSpecificColors.core01_60};
        border-radius: 0;
      }
    }

    ${({ active }) =>
      !!active &&
      css`
        ${fonts.headingXSmall};
        color: ${colors.core01};
        border-bottom: solid 2px ${colors.core01};
        padding-bottom: 14px;
      `}
  }
`;
